import { Component } from '@theme/component';

/**
 * リスト表示の商品1行（#372）。
 *
 * 役割は1つだけで、`quick-add-component` に商品ページへのリンクを渡すこと。
 * quick-add はモーダルの中身を「商品ページを fetch して `[data-product-grid-content]` を
 * 抜き出す」形で作るので、どの商品なのかをリンクから知る必要がある。
 * カード表示では `product-card` が同じ役目を負っている（`getProductCardLink`）。
 */
export class ProductRowYokomo extends Component {
  requiredRefs = ['productRowLink'];

  /**
   * 商品ページへのリンク（quick-add が参照する）
   * @returns {HTMLAnchorElement | null}
   */
  getProductRowLink() {
    const link = this.refs.productRowLink;
    return link instanceof HTMLAnchorElement ? link : null;
  }
}

if (!customElements.get('product-row-yokomo')) {
  customElements.define('product-row-yokomo', ProductRowYokomo);
}
